import { render, staticRenderFns } from "./stuffs.vue?vue&type=template&id=6e4060ef&scoped=true"
import script from "./stuffs.vue?vue&type=script&setup=true&lang=js"
export * from "./stuffs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./stuffs.vue?vue&type=style&index=0&id=6e4060ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4060ef",
  null
  
)

export default component.exports